// extracted by mini-css-extract-plugin
export default {"delimiter":"delimiter--tKuGa","labelSection":"labelSection--XulIf","label":"label--i_fyI","description":"description--dFjd2","warning":"warning--GWvUh","info":"info--tbzxA"};